<!--
 * @FileDescription: 选择榜单
 * @Autor: liuwp
 * @Date: 2022-08-08 14:25:15
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-14 09:30:26
-->
<template>
  <div class="yxtbiz-select-rank">
    <!-- 选择榜单 -->
    <yxt-drawer
      :title="$t('pc_biz_lbl_select_rank')"
      size="960px"
      :visible.sync="visible"
      @close="close"
    >
      <section class="yxtbiz-select-rank-content">
        <div class="yxtbiz-select-rank-table">
          <table-list ref="tableList" v-if="!isGroup" :selectedValue.sync='selectedValue' :tableData.sync='tableData' :maxLength='maxLength' @selectValue='getSelectValue'/>
          <group-table-list ref="groupTableList" v-else :selectedValue.sync='selectedValue' :tableData.sync='tableData' :maxLength='maxLength'  @selectValue='getSelectValue'></group-table-list>
          <div class="yxtbiz-select-rank-table-pagination">
            <yxt-pagination
              class="yxtbiz-select-rank-table-pagination-cmp"
              @current-change="handleCurrentChange"
              :current-page="params.currentPage"
              :page-size="params.pageSize"
              layout="total, prev, pager, next"
              :total="total"
            />
          </div>
        </div>
        <div class="yxtbiz-select-rank-selected">
          <div><span>{{ $t('pc_biz_signup_lbl_checked') }}：{{ selectedValue.length }}<span>/{{ maxLength }}</span></span><yxt-button type="text" @click="clearValue">{{ $t('pc_biz_ote_lbl_clearall') }}</yxt-button></div>
          <ul>
            <li v-for="(item,index) in selectedValue" :key="index">
              <span class="ellipsis">{{ isGroup ? (item.groupChecked ? `${$t('pc_biz_select_rank_group')} | ` : `${$t('pc_biz_select_rank_platform')} | `) : '' }}{{ item.title }}</span>
              <i class="yxt-icon-close" width="16px" height="16px" @click="deleteSelect(item)"></i>
            </li>
          </ul>
        </div>
      </section>
      <div slot="footer">
        <yxt-button plain @click="close">{{ $t('pc_biz_common_cancel_mini') }}</yxt-button>
        <yxt-button type="primary" @click="submit">{{ $t('pc_biz_common_btn_sure') }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>
<script>
import TableList from './component/tableList.vue';
import GroupTableList from './component/groupTableList.vue';
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
export default {
  name: 'YxtbizSelectRank',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 3
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Array,
      default: []
    }
  },
  watch: {
    defaultValue: {
      handler() {
        if (!this.isGroup) {
          this.selectedValue = this.defaultValue;
          return;
        }
        this.selectedValue = this.defaultValue.map(item => {
          return {
            ...item,
            platformChecked: !item.groupChecked
          };
        });
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    TableList,
    GroupTableList
  },
  data() {
    return {
      value: '',
      params: {
        currentPage: 1,
        pageSize: 20
      },
      total: 0,
      selectedValue: [],
      tableData: []
    };
  },
  created() {
    this.listGet();
  },
  methods: {
    handleCurrentChange(v) {
      this.params.currentPage = v;
      this.listGet();
    },
    listGet() {
      apiBaseUrl.get('/rank/decorate/pagelist', {
        params: {
          limit: this.params.pageSize,
          offset: (this.params.currentPage - 1) * this.params.pageSize
        }
      }).then(res => {
        this.tableData = res.datas;
        this.total = res.paging.count;
        if (!this.isGroup && this.$refs.tableList) this.$refs.tableList.checkSelected();
        if (this.isGroup && this.$refs.groupTableList) this.$refs.groupTableList.checkSelected();
      });
    },
    clearValue() {
      this.selectedValue = [];
    },
    deleteSelect(v) {
      if (this.isGroup) {
        let key = v.groupChecked ? 'groupChecked' : 'platformChecked';
        this.selectedValue = this.selectedValue.filter(item => !(item.sourceId === v.sourceId && item[key]));
      } else {
        this.selectedValue = this.selectedValue.filter(item => item.sourceId !== v.sourceId);
      }
    },
    getSelectValue(v) {
      this.selectedValue = v;
    },
    close() {
      this.$emit('update:visible', false);
    },
    submit() {
      this.$emit('submit', this.selectedValue);
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
::v-deep .yxt-drawer__body {
  padding: 0;
}
.yxtbiz-select-rank-content {
  height: 100%;
  display: flex;
  .yxtbiz-select-rank-table {
    box-sizing: border-box;
    width: 660px;
    height: 100%;
    border-right: 1px solid #E9E9E9;
    padding: 24px 16px 0px 24px;
    display: flex;
    flex-direction: column;
    .yxtbiz-select-rank-table-input {
      width: 240px;
      margin-bottom: 16px;
    }
    .yxtbiz-select-rank-table-pagination {
      display: flex;
      justify-content: flex-end;
      .yxtbiz-select-rank-table-pagination-cmp {
        padding: 16px;
      }
    }
  }
  .yxtbiz-select-rank-selected {
    flex: 1;
    padding: 24px 24px 24px 15px;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        height: 36px;
        padding: 8px;
        background-color: #F5F5F5;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        margin-right: 8px;
        color: #595959;
        font-size: 14px;
        span {
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
          height: 100%;
          line-height: 20px;
          text-overflow: ellipsis;
          max-width: 220px;
        }
        .yxt-icon-close {
          margin-left: 3px;
          cursor: pointer;
          color: #BFBFBF;
        }
      }
    }
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 16px;
      span:nth-child(1) {
        color: #262626;
        span {
          color: #757575;
        }
      }
    }
  }
}
</style>